import { IDepartmentState } from '@/store/department';
import { IDepartmentMutations } from './mutations.types';
import { IDepartmentData } from '@/models';

export const mutations: IDepartmentMutations = {
  SET_DEPARTMENTS(state: IDepartmentState, payload: IDepartmentData[]): void {
    state.departments = payload;
  },

  ADD_DEPARTMENT(state: IDepartmentState, payload: IDepartmentData): void {
    state.departments.push(payload);
  },

  UPDATE_DEPARTMENT(state: IDepartmentState, payload: IDepartmentData): void {
    const index = state.departments.findIndex(
      (department: IDepartmentData) => department.id === payload.id
    );

    state.departments.splice(index, 1, payload);
  },

  REMOVE_DEPARTMENT(state: IDepartmentState, payload: number): void {
    const index = state.departments.findIndex(
      (department: IDepartmentData) => department.id === payload
    );

    state.departments.splice(index, 1);
  }
};
